var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{attrs:{"value":_vm.value,"fixed-items":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.fontFamilies),function(fontFamily){return _c('DropdownItem',{key:fontFamily.getType(),attrs:{"value":fontFamily.getType(),"name":fontFamily.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }